import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING } from "../server/feature-flag-tailored-schedule-auditing.mjs"
import { getTailoringChanges } from "./get-tailoring-changes"
import { format } from "date-fns"
import { isTailoringEvent } from "./is-tailoring-event"

export function addTailoringAuditData(row, data) {
    if (!isEnabled(FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING)) return

    const hasTailoredData = !!data?.payload?.tailored
    if (!isTailoringEvent(data?.payload) || !hasTailoredData) return

    row.Schedule = data?.payload?.scheduleTitle
    row.Task = data?.payload?.taskTitle
    row.Changes = getTailoringChanges(data?.payload?.tailored, data?.payload?.original)

    if (data?.payload?.reason) {
        row.JustificationBy = data?.payload?.reasonUser
        row.JustificationDate = format(new Date(data?.payload?.reasonDate), "dd/MM/yyyy")
        row.JustificationTime = format(new Date(data?.payload?.reasonDate), "p")

        if (data?.payload?.rejection?.reason) {
            row.RejectionReason = data?.payload?.rejection?.reason
            row.RejectionBy = data?.payload?.rejection?.user
            if (data?.payload?.rejection?.date) {
                row.RejectionDate = format(new Date(data?.payload?.rejection?.date), "dd/MM/yyyy")
                row.RejectionTime = format(new Date(data?.payload?.rejection?.date), "p")
            }
        }
    }
}
